module.exports = __webpack_public_path__ + "img/rede.0bea71b8.svg";